import * as React from 'react'

import { Box, Divider, Table } from '@factorialco/deprecated-design-system'
import { getUnixTime } from 'date-fns/getUnixTime'
import { parseISO } from 'date-fns/parseISO'
import {
  CompetenciesEmployeesRootPageAssessmentGroupFragment,
  CompetenciesProfileRootPageAssessmentGroupFragment,
} from 'generated/resources/graphql'

import CompetencyRow from './CompetenciesRow'
import Navigator from './Navigator'
import SpiderWeb from './SpiderWeb'

interface Props {
  employeeAssessmentGroups:
    | CompetenciesProfileRootPageAssessmentGroupFragment[]
    | CompetenciesEmployeesRootPageAssessmentGroupFragment[]
}

const toUnixTime = (date: string) => {
  return getUnixTime(parseISO(date))
}

const useUserAssessmentGroups = (
  assessmentGroups:
    | CompetenciesProfileRootPageAssessmentGroupFragment[]
    | CompetenciesEmployeesRootPageAssessmentGroupFragment[]
) => {
  return React.useMemo(() => {
    return [...assessmentGroups].sort(
      (a, b) => toUnixTime(a.publishedAt) - toUnixTime(b.publishedAt)
    )
  }, [assessmentGroups])
}

const Competencies = ({ employeeAssessmentGroups }: Props) => {
  const sortedAssessmentGroups = useUserAssessmentGroups(employeeAssessmentGroups)

  const lastAssessmentPosition = sortedAssessmentGroups.length - 1
  const [currentAssessmentPosition, setCurrentAssessmentPosition] =
    React.useState(lastAssessmentPosition)
  const currentAssessmentGroup = sortedAssessmentGroups[currentAssessmentPosition]

  if (!currentAssessmentGroup) return null

  return (
    <Table>
      <Table.Body>
        <Table.Row>
          <Box flexDirection="column" width="full">
            <Box
              flexDirection="row"
              padding="s16"
              justifyContent="spaceBetween"
              aria-label="assessment-navigator"
              background="grey100"
            >
              <Navigator
                currentPosition={currentAssessmentPosition}
                setCurrentPosition={setCurrentAssessmentPosition}
                lastPosition={lastAssessmentPosition}
                currentDate={toUnixTime(currentAssessmentGroup.publishedAt)}
              />
            </Box>
            <Divider />
            <SpiderWeb assessments={currentAssessmentGroup.assessments} />
            {currentAssessmentGroup.assessments.map((assessment) => {
              return (
                <>
                  <Divider />
                  <CompetencyRow key={assessment.id} assessment={assessment} />
                </>
              )
            })}
          </Box>
        </Table.Row>
      </Table.Body>
    </Table>
  )
}

export default Competencies
